import { Fragment, jsx } from "react/jsx-runtime";
import { useContext, useEffect, useRef } from "react";
import analytics from "../analytics/analytics.js";
import { ChatbotDataContext } from "../context/ChatbotDataContext.js";
const DialogContentWrapper = ({ ariaDescription, chatContainerHeight, children, isAlertDialogActive })=>{
    const { isMobile } = useContext(ChatbotDataContext);
    const styleRef = useRef(null);
    const dialogRef = useRef(null);
    const contentWrapperRef = useRef(null);
    const originalStylesRef = useRef({});
    useEffect(()=>{
        let mounted = true;
        const cleanupStyles = ()=>{
            try {
                if (styleRef.current) {
                    styleRef.current.remove();
                    styleRef.current = null;
                }
                const dialog = dialogRef.current;
                if (dialog && originalStylesRef.current.dialog) Object.entries(originalStylesRef.current.dialog).forEach(([key, value])=>{
                    if (void 0 !== value) dialog.style[key] = value;
                });
                const contentWrapper = contentWrapperRef.current;
                if (contentWrapper && originalStylesRef.current.contentWrapper) Object.entries(originalStylesRef.current.contentWrapper).forEach(([key, value])=>{
                    if (void 0 !== value) contentWrapper.style[key] = value;
                });
                if (!mounted) {
                    dialogRef.current = null;
                    contentWrapperRef.current = null;
                    originalStylesRef.current = {};
                }
            } catch (err) {
                analytics.logError({
                    message: 'DialogContentWrapper Cleanup Error',
                    error: err instanceof Error ? err.message : JSON.stringify(err),
                    context: {
                        ariaDescription,
                        isAlertDialogActive,
                        mounted
                    }
                });
            }
        };
        try {
            const dialog = document.querySelector(`div[aria-describedby="${ariaDescription}"]`);
            if (!dialog || !(dialog instanceof HTMLDivElement)) return void cleanupStyles();
            dialogRef.current = dialog;
            originalStylesRef.current.dialog = {
                height: dialog.style.height || void 0,
                margin: dialog.style.margin || void 0,
                marginTop: dialog.style.marginTop || void 0,
                borderBottomRightRadius: dialog.style.borderBottomRightRadius || void 0,
                borderBottomLeftRadius: dialog.style.borderBottomLeftRadius || void 0
            };
            if (isMobile) {
                dialog.style.height = 'calc(100% - 25px)';
                dialog.style.margin = '0px';
                dialog.style.marginTop = '25px';
                dialog.style.borderBottomRightRadius = '0px';
                dialog.style.borderBottomLeftRadius = '0px';
            } else dialog.style.height = chatContainerHeight;
            const contentWrapper = dialog.querySelector('div');
            if (contentWrapper instanceof HTMLDivElement) {
                contentWrapperRef.current = contentWrapper;
                originalStylesRef.current.contentWrapper = {
                    height: contentWrapper.style.height || void 0,
                    display: contentWrapper.style.display || void 0
                };
                contentWrapper.style.height = '100%';
                contentWrapper.style.display = 'block';
            }
            const style = document.createElement('style');
            styleRef.current = style;
            style.innerHTML = isAlertDialogActive ? `
          div[role="alertdialog"] {
            pointer-events: auto !important;
          }
          div[role="dialog"] {
            pointer-events: none !important;
          }
        ` : `
          iframe#px-captcha-modal {
            pointer-events: auto;
          }
          div[role="dialog"] {
            pointer-events: auto !important;
          }
        `;
            document.head.appendChild(style);
        } catch (err) {
            cleanupStyles();
            analytics.logError({
                message: 'DialogContentWrapper Error',
                error: err instanceof Error ? err.message : JSON.stringify(err),
                context: {
                    ariaDescription,
                    isAlertDialogActive
                }
            });
        }
        return ()=>{
            mounted = false;
            cleanupStyles();
        };
    }, [
        isAlertDialogActive,
        isMobile,
        chatContainerHeight,
        ariaDescription
    ]);
    return /*#__PURE__*/ jsx(Fragment, {
        children: children
    });
};
export { DialogContentWrapper };
